import React, { Fragment } from "react";
import Typography from "@mui/material/Typography";

import { SNETButton } from "shared/dist/components";
import UploadDemoFiles from "./UploadDemoFiles";
import classes from "./Demo.module.css";

const DemoCreationComponent = ({ selectedFile, uploadDemoFilesDetails }) => {
    return (
        <Fragment>
            <span>The steps for creating a demo UI are:</span>
            <div className={classes.stepOneContainer}>
                <Typography variant="subtitle1" className={classes.stepsHeading}>
                    Step 1: Download DApp source code
                </Typography>
                <Typography variant="subtitle2">
                    The DApp source code enables you to build and test the interface for your
                    service. You can also peruse available UI components at &nbsp;
                    <a
                        href="http://custom-ui.singularitynet.io.s3-website-us-east-1.amazonaws.com/?path=/story/alerts-alertbox--live-source"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        SingularityNet storybook
                    </a>
                    . This lists all common components used in the marketplace and can be reused for
                    your service. Download the package from the following link and follow the
                    instructions to set up a local environment.
                </Typography>
                <div className={classes.downloadBtn}>
                    <a href="https://github.com/singnet/snet-dapp/archive/master.zip" download>
                        <SNETButton
                            children="download source code"
                            color="primary"
                            variant="contained"
                        />
                    </a>
                </div>
                <hr />
            </div>
            <div className={classes.stepTwoContainer}>
                <Typography variant="subtitle1" className={classes.stepsHeading}>
                    Step 2: Set Up Local Test Environment (ensure your node version is 10.20.0 or
                    later)
                </Typography>
                <Typography variant="subtitle2">
                    Once you download the package extract the source code and follow the
                    instructions detailed &nbsp;
                    <a
                        href="https://dev.singularitynet.io/docs/products/DecentralizedAIPlatform/Sandbox/version-2/"
                        rel="noopener noreferrer"
                        target="_blank"
                    >
                        here{" "}
                    </a>
                </Typography>
                <div className={classes.stepTwoBtnsContaier}>
                    <Typography variant="subtitle2">Getting stuck or have questions?</Typography>
                    <SNETButton
                        children="setup docs"
                        color="primary"
                        variant="outlined"
                        href="https://dev.singularitynet.io/docs/products/DecentralizedAIPlatform/Sandbox/version-2/"
                        target="_blank"
                        rel="noopener nofollow"
                    />
                    <SNETButton
                        children="contact us"
                        href="mailto:support@singularitynet.io"
                        color="primary"
                        variant="outlined"
                        target="_blank"
                    />
                </div>
                <hr />
            </div>
            <UploadDemoFiles
                selectedFile={selectedFile}
                uploadDemoFilesDetails={uploadDemoFilesDetails}
            />
        </Fragment>
    );
};

export default DemoCreationComponent;
